import React from 'react';
import { StyledTabItemsWrapper } from './styles';

export const TabItemsWrapper: React.FC = ({ children }) => (
    <StyledTabItemsWrapper ml='20px'>
        {children}
    </StyledTabItemsWrapper>
);
